import { CategoryState, CategoryActionTypes } from './types'

export type GlobalMaterialFolderItem = {
  itemId: string
  categoryId: string
  title: string
  category: string
  categoryImage: string | null
  categoryTag: string
  categoryTitle: string
  categoryDescription: string
  materialCategories: GlobalMaterialCategory[]
  materialImage: string | null
  materialTitle: string
  materialDescription: string
  materialDetailsDescription: string
  successContent: string
}

export type GlobalMaterialCategory = {
  title: string
  description: string
  icon: string | null
  placeholder: string
  materials: GlobalMaterial[]
}

export type GlobalMaterial = {
  id: string | null
  title: string
  file: string
}

export type Categories = {
  [key: string]: GlobalMaterialFolderItem[]
}

const initialCategories = window.store.reduce<Categories>((acc, cur) => {
  const newElement: GlobalMaterialFolderItem = {
    ...cur,
    categoryId: cur.category.replace(/ /gi, '-').toLowerCase(),
    itemId: cur.title.replace(/ /gi, '-').toLowerCase()
  }

  return {
    ...acc,
    [cur.category]: Reflect.has(acc, cur.category) ? [...acc[cur.category], newElement] : [newElement]
  }
}, {})

const initialState: CategoryState = {
  categories: initialCategories
}

export function categoriesReducer(state = initialState, action: CategoryActionTypes): CategoryState {
  switch (action.type) {
    default:
      return state
  }
}
